<template>
	<div class="viodeAssembly">
		<topTitle :topTitleInfo="titleData" v-if="!topTitleState"></topTitle>
		<div class="videoBox">
			<!--   x5-video-player-type="h5" x5-video-orientation="landscape" -->
			<video id="video" :src="videoUrl" controls="controls" autoplay></video>
		</div>
	</div>
</template>

<script>
import topTitle from "@/components/panorama/topTitle.vue";
export default{
	data(){
		return {
			musicState: 0,
			soundState: 0,
            menuIndex: this.$store.state.menuIndex, // 当前板块索引
            titleData: {},
		}
	},
	props: ["topTitleInfo","videoUrl","topTitleState"],
	components: {
		topTitle
    },
    created(){
        this.titleData = this.topTitleInfo;
    },
	mounted(){
		setTimeout(() => {
			document.getElementById("video").play();
			// 如果背景音乐正在播放
			// 流程板块判断音乐
			if(this.$store.state.musicState){
				this.musicState = 1;
				// 改变状态，暂停背景音乐
				this.$store.commit('setAudioFlag',3);
			}
			// 简介和流程之外的判断解说
			if(this.menuIndex == 1 || this.menuIndex == 4 || this.menuIndex == 5){
				if(this.$store.state.soundState){
					this.soundState = 1;
					this.$store.commit('setAudioFlag',3);
				}
			}
		},500);
	},
	beforeDestroy(){
		if(this.menuIndex == 2 || this.menuIndex == 3){
			if(this.musicState && !this.$store.state.musicState){
				this.musicState = 0;
				this.$store.commit('setAudioFlag',1);
				// this.$store.commit('setmusicState',1);
			}
		}
		if(this.menuIndex == 1 || this.menuIndex == 4 || this.menuIndex == 5){
			if(this.soundState && !this.$store.state.soundState){
				this.soundState = 0;
				this.$store.commit('setAudioFlag',2);
			}else{
				if(this.musicState){
					this.$store.commit('setAudioFlag',1);
				}
			}
			
		}
    },
    watch: {
        topTitleInfo(nv){
            console.log("*************************");
            console.log(nv);
            console.log("*************************");
            this.titleData = nv;
        },
    }
}
</script>

<style lang="scss" scoped>
.viodeAssembly{
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background: #111;
	z-index: 1004;
	.videoBox{
		width: 100%;
		height: 100%;
		position: relative;
	}
}
@media screen and (orientation: portrait) {
	video{
		width: 100%;
		height: 4.2rem;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}
}
@media screen and (orientation: landscape){
	video{
		width: 100%;
		height:100%;
		position: absolute;
		left: 0;
		top: 0;
	}
}
</style>
